import React from 'react'

const PasswordChangeSuccessView = ({ strings }) => {
  return (
    <div className='success-text-box'>
      <p>{strings.pw_success}</p>
    </div>
  )
}

export default PasswordChangeSuccessView
